export const B_TAG = 'B_TAG';
export const PHASE = 'PHASE';
export const B_TAG_AND_PHASE = 'B_TAG_AND_PHASE';
export const WITHOUT_SEGMENTATION = 'WITHOUT_SEGMENTATION';

export const NEW_PHASE = 'new';
export const UPGRADE_PHASE = 'upgrade';
